import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";

export default function SearchBox({ setQuery, query, count }) {
    const [search, setSearch] = useState(query.search || "");

    useEffect(() => {
        setSearch(query.search || "")
    }, [query.search]);

    const handleSearch = () => {
        setQuery((prev) => ({ ...prev, search, page: 1 }));
    };

    return (
        <div className="flex items-center gap-2 mt-3 mb-4 max-w-md ml-auto">
            <div className="relative flex-grow">
                <input
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleSearch();
                        }
                    }}
                    id="search-bar-0"
                    type="text"
                    className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f6475f] focus:border-transparent text-sm transition-all"
                    placeholder={`${count} Search...`}
                    value={search}
                />
                <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg" />
            </div>
            <button
                onClick={handleSearch}
                className="px-4 py-2 bg-[#f6475f] hover:bg-[#e03e52] text-white text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap"
            >
                Search
            </button>
        </div>
    );
}